module.exports = __webpack_public_path__ + "static/e-what-is-ecommerce-1969f98b042c75b7ddec0799802db8be.png";